var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[(_vm.menu)?_c('MenuList',{attrs:{"responsive":_vm.responsive,"lang":_vm.lang,"list":_vm.menu.list}}):_vm._e(),_c('Sns',{attrs:{"list":_vm.sns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }